import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import { SelectTreeProps } from './type';
import NodeRender from './NodeRender';

const TreeRender: ForwardRefExoticComponent<PropsWithoutRef<SelectTreeProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    handleNodeClick,
    currentSelectNode,
    data,
    targetIndex,
    parentNode,
    onChange,
  },
  ref,
) => {
  const { children = [], collapsed } = data;

  const childUIs = children?.map((child: any, index: number) => (
    <TreeRender
      key={index}
      targetIndex={index}
      data={child}
      parentNode={data}
      currentSelectNode={currentSelectNode}
      handleNodeClick={handleNodeClick}
      onChange={onChange}
    />
  ));

  return (
    <div className={styles.role_node_wrap}>
      {parentNode && (
        <>
          {targetIndex !== 0 && <div className={styles.column_top_line} />}
          {targetIndex !== (parentNode as any)?.children?.length - 1 && (
            <div className={styles.column_line} />
          )}
          <div className={styles.row_line} />
        </>
      )}

      <NodeRender
        data={data}
        handleNodeClick={handleNodeClick}
        currentSelectNode={currentSelectNode}
      />

      {!!children?.length && (
        <div className={styles.custom_footer} >
          <div
            className={styles.event_icon}
            onClick={() => {
              data.collapsed = !collapsed;
              onChange && onChange();
            }}
          >
            <span className={styles.event_icon_content}>{collapsed ? '+' : '-'}</span>
          </div>
          {collapsed && children?.length && (
            <div className={styles.child_num}>
              <div className={styles.child_num_line} />
              <div className={styles.child_num_text}>+{children?.length}</div>
            </div>
          )}
        </div>
      )}
      {!collapsed && (
        <>
          {!!children?.length && <div className={styles.expend_line} />}
          <div className={styles.children_Wrap}>{childUIs}</div>
        </>
      )}
    </div>
  );
});

export default TreeRender;
